/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as KioskRouteImport } from './routes/kiosk'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth.forgot-password'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth.reset-password'
import { Route as AuthSignInRouteImport } from './routes/_auth.sign-in'
import { Route as AuthSignUpRouteImport } from './routes/_auth.sign-up'
import { Route as AuthedShellRouteImport } from './routes/_authed._shell'
import { Route as AuthedAdminRouteImport } from './routes/_authed.admin'
import { Route as AuthedAppsRouteImport } from './routes/_authed.apps'
import { Route as AuthedDeviceRouteImport } from './routes/_authed.device'
import { Route as AuthedOnboardingRouteImport } from './routes/_authed.onboarding'
import { Route as AuthedSpotifyRouteImport } from './routes/_authed.spotify'
import { Route as AcceptInvitationInvitationIdRouteImport } from './routes/accept-invitation.$invitationId'
import { Route as GiveSlugRouteImport } from './routes/give.$slug'
import { Route as PreferencesRefRouteImport } from './routes/preferences.$ref'
import { Route as UnsubscribeRefRouteImport } from './routes/unsubscribe.$ref'
import { Route as AuthedShellIndexRouteImport } from './routes/_authed._shell.index'
import { Route as AuthedShellAttendanceRouteImport } from './routes/_authed._shell.attendance'
import { Route as AuthedShellCheckinRouteImport } from './routes/_authed._shell.checkin'
import { Route as AuthedShellFacilitiesRouteImport } from './routes/_authed._shell.facilities'
import { Route as AuthedShellGivingRouteImport } from './routes/_authed._shell.giving'
import { Route as AuthedShellMyScheduleRouteImport } from './routes/_authed._shell.my-schedule'
import { Route as AuthedShellReportsRouteImport } from './routes/_authed._shell.reports'
import { Route as AuthedShellSettingsRouteImport } from './routes/_authed._shell.settings'
import { Route as AuthedShellTasksRouteImport } from './routes/_authed._shell.tasks'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed.admin.index'
import { Route as AuthedAdminAiRouteImport } from './routes/_authed.admin.ai'
import { Route as AuthedAdminCatalogRouteImport } from './routes/_authed.admin.catalog'
import { Route as AuthedAdminLogRouteImport } from './routes/_authed.admin.log'
import { Route as AuthedAdminPlansRouteImport } from './routes/_authed.admin.plans'
import { Route as AuthedAdminSpotifyRouteImport } from './routes/_authed.admin.spotify'
import { Route as AuthedStandPlanIdRouteImport } from './routes/_authed.stand.$planId'
import { Route as AuthedShellEventsIndexRouteImport } from './routes/_authed._shell.events.index'
import { Route as AuthedShellGroupsIndexRouteImport } from './routes/_authed._shell.groups.index'
import { Route as AuthedShellGroupsIdRouteImport } from './routes/_authed._shell.groups.$id'
import { Route as AuthedShellListsIndexRouteImport } from './routes/_authed._shell.lists.index'
import { Route as AuthedShellListsIdRouteImport } from './routes/_authed._shell.lists.$id'
import { Route as AuthedShellMessagesIndexRouteImport } from './routes/_authed._shell.messages.index'
import { Route as AuthedShellMessagesIdRouteImport } from './routes/_authed._shell.messages.$id'
import { Route as AuthedShellPeopleIndexRouteImport } from './routes/_authed._shell.people.index'
import { Route as AuthedShellPeopleIdRouteImport } from './routes/_authed._shell.people.$id'
import { Route as AuthedShellPeopleDuplicatesRouteImport } from './routes/_authed._shell.people.duplicates'
import { Route as AuthedShellPeopleImportRouteImport } from './routes/_authed._shell.people.import'
import { Route as AuthedShellServicesIndexRouteImport } from './routes/_authed._shell.services.index'
import { Route as AuthedShellServicesSectionsRouteImport } from './routes/_authed._shell.services._sections'
import { Route as AuthedShellServicesSharedTeamsRouteImport } from './routes/_authed._shell.services.shared-teams'
import { Route as AuthedShellSettingsIndexRouteImport } from './routes/_authed._shell.settings.index'
import { Route as AuthedShellSettingsAccountRouteImport } from './routes/_authed._shell.settings.account'
import { Route as AuthedShellSettingsAuditLogRouteImport } from './routes/_authed._shell.settings.audit-log'
import { Route as AuthedShellSettingsBillingRouteImport } from './routes/_authed._shell.settings.billing'
import { Route as AuthedShellSettingsCampusesRouteImport } from './routes/_authed._shell.settings.campuses'
import { Route as AuthedShellSettingsCustomFieldsRouteImport } from './routes/_authed._shell.settings.custom-fields'
import { Route as AuthedShellSettingsDevelopersRouteImport } from './routes/_authed._shell.settings.developers'
import { Route as AuthedShellSettingsGroupTypesRouteImport } from './routes/_authed._shell.settings.group-types'
import { Route as AuthedShellSettingsInvitationsRouteImport } from './routes/_authed._shell.settings.invitations'
import { Route as AuthedShellSettingsPlanningCenterRouteImport } from './routes/_authed._shell.settings.planning-center'
import { Route as AuthedShellSettingsProfileRouteImport } from './routes/_authed._shell.settings.profile'
import { Route as AuthedShellSettingsRolesRouteImport } from './routes/_authed._shell.settings.roles'
import { Route as AuthedShellSettingsServicesRouteImport } from './routes/_authed._shell.settings.services'
import { Route as AuthedShellSettingsStaffRouteImport } from './routes/_authed._shell.settings.staff'
import { Route as AuthedShellSettingsTagsRouteImport } from './routes/_authed._shell.settings.tags'
import { Route as AuthedAdminChurchesIdRouteImport } from './routes/_authed.admin.churches.$id'
import { Route as AuthedShellEventsInstancesIdRouteImport } from './routes/_authed._shell.events.instances.$id'
import { Route as AuthedShellMessagesWorkflowsIdRouteImport } from './routes/_authed._shell.messages.workflows.$id'
import { Route as AuthedShellServicesSectionsScheduleRouteImport } from './routes/_authed._shell.services._sections.schedule'
import { Route as AuthedShellServicesSectionsTeamsRouteImport } from './routes/_authed._shell.services._sections.teams'
import { Route as AuthedShellServicesPlansIdRouteImport } from './routes/_authed._shell.services.plans.$id'
import { Route as AuthedShellServicesSectionsPeopleIndexRouteImport } from './routes/_authed._shell.services._sections.people.index'
import { Route as AuthedShellServicesSectionsPeoplePersonIdRouteImport } from './routes/_authed._shell.services._sections.people.$personId'
import { Route as AuthedShellServicesSectionsPlansIndexRouteImport } from './routes/_authed._shell.services._sections.plans.index'
import { Route as AuthedShellServicesSectionsSermonsIndexRouteImport } from './routes/_authed._shell.services._sections.sermons.index'
import { Route as AuthedShellServicesSectionsSermonsPlannerRouteImport } from './routes/_authed._shell.services._sections.sermons.planner'
import { Route as AuthedShellServicesSectionsSongsIndexRouteImport } from './routes/_authed._shell.services._sections.songs.index'
import { Route as AuthedShellServicesSectionsSongsDiscoverRouteImport } from './routes/_authed._shell.services._sections.songs.discover'
import { Route as AuthedShellServicesSectionsTypesTypeIdRouteImport } from './routes/_authed._shell.services._sections.types.$typeId'
import { Route as AuthedShellServicesArrangementsArrangementIdChartRouteImport } from './routes/_authed._shell.services.arrangements.$arrangementId.chart'
import { Route as AuthedShellServicesPlansIdSermonRouteImport } from './routes/_authed._shell.services.plans.$id_.sermon'
import { Route as AuthedShellServicesPlansIdSuggestionsRouteImport } from './routes/_authed._shell.services.plans.$id_.suggestions'
import { Route as AuthedShellServicesTypesTypeIdSettingsRouteImport } from './routes/_authed._shell.services.types.$typeId.settings'
import { Route as AuthedShellServicesSectionsSongsSongIdIndexRouteImport } from './routes/_authed._shell.services._sections.songs.$songId.index'
import { Route as AuthedShellServicesPlansIdSermonKindRouteImport } from './routes/_authed._shell.services.plans.$id_.sermon_.$kind'
import { Route as AuthedShellServicesTypesTypeIdTemplatesIndexRouteImport } from './routes/_authed._shell.services.types.$typeId.templates.index'
import { Route as AuthedShellServicesTypesTypeIdTemplatesTemplateIdRouteImport } from './routes/_authed._shell.services.types.$typeId.templates.$templateId'
import { Route as AuthedShellServicesSectionsSongsSongIdArrangementsArrangementIdRouteImport } from './routes/_authed._shell.services._sections.songs.$songId.arrangements.$arrangementId'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const KioskRoute = KioskRouteImport.update({
  id: '/kiosk',
  path: '/kiosk',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthedShellRoute = AuthedShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAppsRoute = AuthedAppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDeviceRoute = AuthedDeviceRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOnboardingRoute = AuthedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSpotifyRoute = AuthedSpotifyRouteImport.update({
  id: '/spotify',
  path: '/spotify',
  getParentRoute: () => AuthedRoute,
} as any)
const AcceptInvitationInvitationIdRoute =
  AcceptInvitationInvitationIdRouteImport.update({
    id: '/accept-invitation/$invitationId',
    path: '/accept-invitation/$invitationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const GiveSlugRoute = GiveSlugRouteImport.update({
  id: '/give/$slug',
  path: '/give/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PreferencesRefRoute = PreferencesRefRouteImport.update({
  id: '/preferences/$ref',
  path: '/preferences/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeRefRoute = UnsubscribeRefRouteImport.update({
  id: '/unsubscribe/$ref',
  path: '/unsubscribe/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedShellIndexRoute = AuthedShellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellAttendanceRoute = AuthedShellAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellCheckinRoute = AuthedShellCheckinRouteImport.update({
  id: '/checkin',
  path: '/checkin',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellFacilitiesRoute = AuthedShellFacilitiesRouteImport.update({
  id: '/facilities',
  path: '/facilities',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellGivingRoute = AuthedShellGivingRouteImport.update({
  id: '/giving',
  path: '/giving',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellMyScheduleRoute = AuthedShellMyScheduleRouteImport.update({
  id: '/my-schedule',
  path: '/my-schedule',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellReportsRoute = AuthedShellReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellSettingsRoute = AuthedShellSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellTasksRoute = AuthedShellTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminAiRoute = AuthedAdminAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminCatalogRoute = AuthedAdminCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminLogRoute = AuthedAdminLogRouteImport.update({
  id: '/log',
  path: '/log',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminPlansRoute = AuthedAdminPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminSpotifyRoute = AuthedAdminSpotifyRouteImport.update({
  id: '/spotify',
  path: '/spotify',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedStandPlanIdRoute = AuthedStandPlanIdRouteImport.update({
  id: '/stand/$planId',
  path: '/stand/$planId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedShellEventsIndexRoute = AuthedShellEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellGroupsIndexRoute = AuthedShellGroupsIndexRouteImport.update({
  id: '/groups/',
  path: '/groups/',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellGroupsIdRoute = AuthedShellGroupsIdRouteImport.update({
  id: '/groups/$id',
  path: '/groups/$id',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellListsIndexRoute = AuthedShellListsIndexRouteImport.update({
  id: '/lists/',
  path: '/lists/',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellListsIdRoute = AuthedShellListsIdRouteImport.update({
  id: '/lists/$id',
  path: '/lists/$id',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellMessagesIndexRoute =
  AuthedShellMessagesIndexRouteImport.update({
    id: '/messages/',
    path: '/messages/',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellMessagesIdRoute = AuthedShellMessagesIdRouteImport.update({
  id: '/messages/$id',
  path: '/messages/$id',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellPeopleIndexRoute = AuthedShellPeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellPeopleIdRoute = AuthedShellPeopleIdRouteImport.update({
  id: '/people/$id',
  path: '/people/$id',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellPeopleDuplicatesRoute =
  AuthedShellPeopleDuplicatesRouteImport.update({
    id: '/people/duplicates',
    path: '/people/duplicates',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellPeopleImportRoute = AuthedShellPeopleImportRouteImport.update({
  id: '/people/import',
  path: '/people/import',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellServicesIndexRoute =
  AuthedShellServicesIndexRouteImport.update({
    id: '/services/',
    path: '/services/',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellServicesSectionsRoute =
  AuthedShellServicesSectionsRouteImport.update({
    id: '/services/_sections',
    path: '/services',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellServicesSharedTeamsRoute =
  AuthedShellServicesSharedTeamsRouteImport.update({
    id: '/services/shared-teams',
    path: '/services/shared-teams',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellSettingsIndexRoute =
  AuthedShellSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedShellSettingsRoute,
  } as any)
const AuthedShellSettingsAccountRoute =
  AuthedShellSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthedShellSettingsRoute,
  } as any)
const AuthedShellSettingsAuditLogRoute =
  AuthedShellSettingsAuditLogRouteImport.update({
    id: '/audit-log',
    path: '/audit-log',
    getParentRoute: () => AuthedShellSettingsRoute,
  } as any)
const AuthedShellSettingsBillingRoute =
  AuthedShellSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthedShellSettingsRoute,
  } as any)
const AuthedShellSettingsCampusesRoute =
  AuthedShellSettingsCampusesRouteImport.update({
    id: '/campuses',
    path: '/campuses',
    getParentRoute: () => AuthedShellSettingsRoute,
  } as any)
const AuthedShellSettingsCustomFieldsRoute =
  AuthedShellSettingsCustomFieldsRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () => AuthedShellSettingsRoute,
  } as any)
const AuthedShellSettingsDevelopersRoute =
  AuthedShellSettingsDevelopersRouteImport.update({
    id: '/developers',
    path: '/developers',
    getParentRoute: () => AuthedShellSettingsRoute,
  } as any)
const AuthedShellSettingsGroupTypesRoute =
  AuthedShellSettingsGroupTypesRouteImport.update({
    id: '/group-types',
    path: '/group-types',
    getParentRoute: () => AuthedShellSettingsRoute,
  } as any)
const AuthedShellSettingsInvitationsRoute =
  AuthedShellSettingsInvitationsRouteImport.update({
    id: '/invitations',
    path: '/invitations',
    getParentRoute: () => AuthedShellSettingsRoute,
  } as any)
const AuthedShellSettingsPlanningCenterRoute =
  AuthedShellSettingsPlanningCenterRouteImport.update({
    id: '/planning-center',
    path: '/planning-center',
    getParentRoute: () => AuthedShellSettingsRoute,
  } as any)
const AuthedShellSettingsProfileRoute =
  AuthedShellSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthedShellSettingsRoute,
  } as any)
const AuthedShellSettingsRolesRoute =
  AuthedShellSettingsRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthedShellSettingsRoute,
  } as any)
const AuthedShellSettingsServicesRoute =
  AuthedShellSettingsServicesRouteImport.update({
    id: '/services',
    path: '/services',
    getParentRoute: () => AuthedShellSettingsRoute,
  } as any)
const AuthedShellSettingsStaffRoute =
  AuthedShellSettingsStaffRouteImport.update({
    id: '/staff',
    path: '/staff',
    getParentRoute: () => AuthedShellSettingsRoute,
  } as any)
const AuthedShellSettingsTagsRoute = AuthedShellSettingsTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AuthedShellSettingsRoute,
} as any)
const AuthedAdminChurchesIdRoute = AuthedAdminChurchesIdRouteImport.update({
  id: '/churches/$id',
  path: '/churches/$id',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedShellEventsInstancesIdRoute =
  AuthedShellEventsInstancesIdRouteImport.update({
    id: '/events/instances/$id',
    path: '/events/instances/$id',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellMessagesWorkflowsIdRoute =
  AuthedShellMessagesWorkflowsIdRouteImport.update({
    id: '/messages/workflows/$id',
    path: '/messages/workflows/$id',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellServicesSectionsScheduleRoute =
  AuthedShellServicesSectionsScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => AuthedShellServicesSectionsRoute,
  } as any)
const AuthedShellServicesSectionsTeamsRoute =
  AuthedShellServicesSectionsTeamsRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () => AuthedShellServicesSectionsRoute,
  } as any)
const AuthedShellServicesPlansIdRoute =
  AuthedShellServicesPlansIdRouteImport.update({
    id: '/services/plans/$id',
    path: '/services/plans/$id',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellServicesSectionsPeopleIndexRoute =
  AuthedShellServicesSectionsPeopleIndexRouteImport.update({
    id: '/people/',
    path: '/people/',
    getParentRoute: () => AuthedShellServicesSectionsRoute,
  } as any)
const AuthedShellServicesSectionsPeoplePersonIdRoute =
  AuthedShellServicesSectionsPeoplePersonIdRouteImport.update({
    id: '/people/$personId',
    path: '/people/$personId',
    getParentRoute: () => AuthedShellServicesSectionsRoute,
  } as any)
const AuthedShellServicesSectionsPlansIndexRoute =
  AuthedShellServicesSectionsPlansIndexRouteImport.update({
    id: '/plans/',
    path: '/plans/',
    getParentRoute: () => AuthedShellServicesSectionsRoute,
  } as any)
const AuthedShellServicesSectionsSermonsIndexRoute =
  AuthedShellServicesSectionsSermonsIndexRouteImport.update({
    id: '/sermons/',
    path: '/sermons/',
    getParentRoute: () => AuthedShellServicesSectionsRoute,
  } as any)
const AuthedShellServicesSectionsSermonsPlannerRoute =
  AuthedShellServicesSectionsSermonsPlannerRouteImport.update({
    id: '/sermons/planner',
    path: '/sermons/planner',
    getParentRoute: () => AuthedShellServicesSectionsRoute,
  } as any)
const AuthedShellServicesSectionsSongsIndexRoute =
  AuthedShellServicesSectionsSongsIndexRouteImport.update({
    id: '/songs/',
    path: '/songs/',
    getParentRoute: () => AuthedShellServicesSectionsRoute,
  } as any)
const AuthedShellServicesSectionsSongsDiscoverRoute =
  AuthedShellServicesSectionsSongsDiscoverRouteImport.update({
    id: '/songs/discover',
    path: '/songs/discover',
    getParentRoute: () => AuthedShellServicesSectionsRoute,
  } as any)
const AuthedShellServicesSectionsTypesTypeIdRoute =
  AuthedShellServicesSectionsTypesTypeIdRouteImport.update({
    id: '/types/$typeId',
    path: '/types/$typeId',
    getParentRoute: () => AuthedShellServicesSectionsRoute,
  } as any)
const AuthedShellServicesArrangementsArrangementIdChartRoute =
  AuthedShellServicesArrangementsArrangementIdChartRouteImport.update({
    id: '/services/arrangements/$arrangementId/chart',
    path: '/services/arrangements/$arrangementId/chart',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellServicesPlansIdSermonRoute =
  AuthedShellServicesPlansIdSermonRouteImport.update({
    id: '/services/plans/$id_/sermon',
    path: '/services/plans/$id/sermon',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellServicesPlansIdSuggestionsRoute =
  AuthedShellServicesPlansIdSuggestionsRouteImport.update({
    id: '/services/plans/$id_/suggestions',
    path: '/services/plans/$id/suggestions',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellServicesTypesTypeIdSettingsRoute =
  AuthedShellServicesTypesTypeIdSettingsRouteImport.update({
    id: '/services/types/$typeId/settings',
    path: '/services/types/$typeId/settings',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellServicesSectionsSongsSongIdIndexRoute =
  AuthedShellServicesSectionsSongsSongIdIndexRouteImport.update({
    id: '/songs/$songId/',
    path: '/songs/$songId/',
    getParentRoute: () => AuthedShellServicesSectionsRoute,
  } as any)
const AuthedShellServicesPlansIdSermonKindRoute =
  AuthedShellServicesPlansIdSermonKindRouteImport.update({
    id: '/services/plans/$id_/sermon_/$kind',
    path: '/services/plans/$id/sermon/$kind',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellServicesTypesTypeIdTemplatesIndexRoute =
  AuthedShellServicesTypesTypeIdTemplatesIndexRouteImport.update({
    id: '/services/types/$typeId/templates/',
    path: '/services/types/$typeId/templates/',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellServicesTypesTypeIdTemplatesTemplateIdRoute =
  AuthedShellServicesTypesTypeIdTemplatesTemplateIdRouteImport.update({
    id: '/services/types/$typeId/templates/$templateId',
    path: '/services/types/$typeId/templates/$templateId',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellServicesSectionsSongsSongIdArrangementsArrangementIdRoute =
  AuthedShellServicesSectionsSongsSongIdArrangementsArrangementIdRouteImport.update(
    {
      id: '/songs/$songId/arrangements/$arrangementId',
      path: '/songs/$songId/arrangements/$arrangementId',
      getParentRoute: () => AuthedShellServicesSectionsRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthedShellIndexRoute
  '/kiosk': typeof KioskRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/admin': typeof AuthedAdminRouteWithChildren
  '/apps': typeof AuthedAppsRoute
  '/device': typeof AuthedDeviceRoute
  '/onboarding': typeof AuthedOnboardingRoute
  '/spotify': typeof AuthedSpotifyRoute
  '/accept-invitation/$invitationId': typeof AcceptInvitationInvitationIdRoute
  '/give/$slug': typeof GiveSlugRoute
  '/preferences/$ref': typeof PreferencesRefRoute
  '/unsubscribe/$ref': typeof UnsubscribeRefRoute
  '/attendance': typeof AuthedShellAttendanceRoute
  '/checkin': typeof AuthedShellCheckinRoute
  '/facilities': typeof AuthedShellFacilitiesRoute
  '/giving': typeof AuthedShellGivingRoute
  '/my-schedule': typeof AuthedShellMyScheduleRoute
  '/reports': typeof AuthedShellReportsRoute
  '/settings': typeof AuthedShellSettingsRouteWithChildren
  '/tasks': typeof AuthedShellTasksRoute
  '/admin/ai': typeof AuthedAdminAiRoute
  '/admin/catalog': typeof AuthedAdminCatalogRoute
  '/admin/log': typeof AuthedAdminLogRoute
  '/admin/plans': typeof AuthedAdminPlansRoute
  '/admin/spotify': typeof AuthedAdminSpotifyRoute
  '/stand/$planId': typeof AuthedStandPlanIdRoute
  '/admin/': typeof AuthedAdminIndexRoute
  '/groups/$id': typeof AuthedShellGroupsIdRoute
  '/lists/$id': typeof AuthedShellListsIdRoute
  '/messages/$id': typeof AuthedShellMessagesIdRoute
  '/people/$id': typeof AuthedShellPeopleIdRoute
  '/people/duplicates': typeof AuthedShellPeopleDuplicatesRoute
  '/people/import': typeof AuthedShellPeopleImportRoute
  '/services': typeof AuthedShellServicesSectionsRouteWithChildren
  '/services/shared-teams': typeof AuthedShellServicesSharedTeamsRoute
  '/settings/account': typeof AuthedShellSettingsAccountRoute
  '/settings/audit-log': typeof AuthedShellSettingsAuditLogRoute
  '/settings/billing': typeof AuthedShellSettingsBillingRoute
  '/settings/campuses': typeof AuthedShellSettingsCampusesRoute
  '/settings/custom-fields': typeof AuthedShellSettingsCustomFieldsRoute
  '/settings/developers': typeof AuthedShellSettingsDevelopersRoute
  '/settings/group-types': typeof AuthedShellSettingsGroupTypesRoute
  '/settings/invitations': typeof AuthedShellSettingsInvitationsRoute
  '/settings/planning-center': typeof AuthedShellSettingsPlanningCenterRoute
  '/settings/profile': typeof AuthedShellSettingsProfileRoute
  '/settings/roles': typeof AuthedShellSettingsRolesRoute
  '/settings/services': typeof AuthedShellSettingsServicesRoute
  '/settings/staff': typeof AuthedShellSettingsStaffRoute
  '/settings/tags': typeof AuthedShellSettingsTagsRoute
  '/admin/churches/$id': typeof AuthedAdminChurchesIdRoute
  '/events/': typeof AuthedShellEventsIndexRoute
  '/groups/': typeof AuthedShellGroupsIndexRoute
  '/lists/': typeof AuthedShellListsIndexRoute
  '/messages/': typeof AuthedShellMessagesIndexRoute
  '/people/': typeof AuthedShellPeopleIndexRoute
  '/services/': typeof AuthedShellServicesIndexRoute
  '/settings/': typeof AuthedShellSettingsIndexRoute
  '/events/instances/$id': typeof AuthedShellEventsInstancesIdRoute
  '/messages/workflows/$id': typeof AuthedShellMessagesWorkflowsIdRoute
  '/services/schedule': typeof AuthedShellServicesSectionsScheduleRoute
  '/services/teams': typeof AuthedShellServicesSectionsTeamsRoute
  '/services/plans/$id': typeof AuthedShellServicesPlansIdRoute
  '/services/people/$personId': typeof AuthedShellServicesSectionsPeoplePersonIdRoute
  '/services/sermons/planner': typeof AuthedShellServicesSectionsSermonsPlannerRoute
  '/services/songs/discover': typeof AuthedShellServicesSectionsSongsDiscoverRoute
  '/services/types/$typeId': typeof AuthedShellServicesSectionsTypesTypeIdRoute
  '/services/arrangements/$arrangementId/chart': typeof AuthedShellServicesArrangementsArrangementIdChartRoute
  '/services/plans/$id/sermon': typeof AuthedShellServicesPlansIdSermonRoute
  '/services/plans/$id/suggestions': typeof AuthedShellServicesPlansIdSuggestionsRoute
  '/services/types/$typeId/settings': typeof AuthedShellServicesTypesTypeIdSettingsRoute
  '/services/people/': typeof AuthedShellServicesSectionsPeopleIndexRoute
  '/services/plans/': typeof AuthedShellServicesSectionsPlansIndexRoute
  '/services/sermons/': typeof AuthedShellServicesSectionsSermonsIndexRoute
  '/services/songs/': typeof AuthedShellServicesSectionsSongsIndexRoute
  '/services/plans/$id/sermon/$kind': typeof AuthedShellServicesPlansIdSermonKindRoute
  '/services/types/$typeId/templates/$templateId': typeof AuthedShellServicesTypesTypeIdTemplatesTemplateIdRoute
  '/services/songs/$songId/': typeof AuthedShellServicesSectionsSongsSongIdIndexRoute
  '/services/types/$typeId/templates/': typeof AuthedShellServicesTypesTypeIdTemplatesIndexRoute
  '/services/songs/$songId/arrangements/$arrangementId': typeof AuthedShellServicesSectionsSongsSongIdArrangementsArrangementIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedShellIndexRoute
  '/kiosk': typeof KioskRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/apps': typeof AuthedAppsRoute
  '/device': typeof AuthedDeviceRoute
  '/onboarding': typeof AuthedOnboardingRoute
  '/spotify': typeof AuthedSpotifyRoute
  '/accept-invitation/$invitationId': typeof AcceptInvitationInvitationIdRoute
  '/give/$slug': typeof GiveSlugRoute
  '/preferences/$ref': typeof PreferencesRefRoute
  '/unsubscribe/$ref': typeof UnsubscribeRefRoute
  '/attendance': typeof AuthedShellAttendanceRoute
  '/checkin': typeof AuthedShellCheckinRoute
  '/facilities': typeof AuthedShellFacilitiesRoute
  '/giving': typeof AuthedShellGivingRoute
  '/my-schedule': typeof AuthedShellMyScheduleRoute
  '/reports': typeof AuthedShellReportsRoute
  '/tasks': typeof AuthedShellTasksRoute
  '/admin/ai': typeof AuthedAdminAiRoute
  '/admin/catalog': typeof AuthedAdminCatalogRoute
  '/admin/log': typeof AuthedAdminLogRoute
  '/admin/plans': typeof AuthedAdminPlansRoute
  '/admin/spotify': typeof AuthedAdminSpotifyRoute
  '/stand/$planId': typeof AuthedStandPlanIdRoute
  '/admin': typeof AuthedAdminIndexRoute
  '/groups/$id': typeof AuthedShellGroupsIdRoute
  '/lists/$id': typeof AuthedShellListsIdRoute
  '/messages/$id': typeof AuthedShellMessagesIdRoute
  '/people/$id': typeof AuthedShellPeopleIdRoute
  '/people/duplicates': typeof AuthedShellPeopleDuplicatesRoute
  '/people/import': typeof AuthedShellPeopleImportRoute
  '/services': typeof AuthedShellServicesIndexRoute
  '/services/shared-teams': typeof AuthedShellServicesSharedTeamsRoute
  '/settings/account': typeof AuthedShellSettingsAccountRoute
  '/settings/audit-log': typeof AuthedShellSettingsAuditLogRoute
  '/settings/billing': typeof AuthedShellSettingsBillingRoute
  '/settings/campuses': typeof AuthedShellSettingsCampusesRoute
  '/settings/custom-fields': typeof AuthedShellSettingsCustomFieldsRoute
  '/settings/developers': typeof AuthedShellSettingsDevelopersRoute
  '/settings/group-types': typeof AuthedShellSettingsGroupTypesRoute
  '/settings/invitations': typeof AuthedShellSettingsInvitationsRoute
  '/settings/planning-center': typeof AuthedShellSettingsPlanningCenterRoute
  '/settings/profile': typeof AuthedShellSettingsProfileRoute
  '/settings/roles': typeof AuthedShellSettingsRolesRoute
  '/settings/services': typeof AuthedShellSettingsServicesRoute
  '/settings/staff': typeof AuthedShellSettingsStaffRoute
  '/settings/tags': typeof AuthedShellSettingsTagsRoute
  '/admin/churches/$id': typeof AuthedAdminChurchesIdRoute
  '/events': typeof AuthedShellEventsIndexRoute
  '/groups': typeof AuthedShellGroupsIndexRoute
  '/lists': typeof AuthedShellListsIndexRoute
  '/messages': typeof AuthedShellMessagesIndexRoute
  '/people': typeof AuthedShellPeopleIndexRoute
  '/settings': typeof AuthedShellSettingsIndexRoute
  '/events/instances/$id': typeof AuthedShellEventsInstancesIdRoute
  '/messages/workflows/$id': typeof AuthedShellMessagesWorkflowsIdRoute
  '/services/schedule': typeof AuthedShellServicesSectionsScheduleRoute
  '/services/teams': typeof AuthedShellServicesSectionsTeamsRoute
  '/services/plans/$id': typeof AuthedShellServicesPlansIdRoute
  '/services/people/$personId': typeof AuthedShellServicesSectionsPeoplePersonIdRoute
  '/services/sermons/planner': typeof AuthedShellServicesSectionsSermonsPlannerRoute
  '/services/songs/discover': typeof AuthedShellServicesSectionsSongsDiscoverRoute
  '/services/types/$typeId': typeof AuthedShellServicesSectionsTypesTypeIdRoute
  '/services/arrangements/$arrangementId/chart': typeof AuthedShellServicesArrangementsArrangementIdChartRoute
  '/services/plans/$id/sermon': typeof AuthedShellServicesPlansIdSermonRoute
  '/services/plans/$id/suggestions': typeof AuthedShellServicesPlansIdSuggestionsRoute
  '/services/types/$typeId/settings': typeof AuthedShellServicesTypesTypeIdSettingsRoute
  '/services/people': typeof AuthedShellServicesSectionsPeopleIndexRoute
  '/services/plans': typeof AuthedShellServicesSectionsPlansIndexRoute
  '/services/sermons': typeof AuthedShellServicesSectionsSermonsIndexRoute
  '/services/songs': typeof AuthedShellServicesSectionsSongsIndexRoute
  '/services/plans/$id/sermon/$kind': typeof AuthedShellServicesPlansIdSermonKindRoute
  '/services/types/$typeId/templates/$templateId': typeof AuthedShellServicesTypesTypeIdTemplatesTemplateIdRoute
  '/services/songs/$songId': typeof AuthedShellServicesSectionsSongsSongIdIndexRoute
  '/services/types/$typeId/templates': typeof AuthedShellServicesTypesTypeIdTemplatesIndexRoute
  '/services/songs/$songId/arrangements/$arrangementId': typeof AuthedShellServicesSectionsSongsSongIdArrangementsArrangementIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_authed': typeof AuthedRouteWithChildren
  '/kiosk': typeof KioskRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/_authed/_shell': typeof AuthedShellRouteWithChildren
  '/_authed/admin': typeof AuthedAdminRouteWithChildren
  '/_authed/apps': typeof AuthedAppsRoute
  '/_authed/device': typeof AuthedDeviceRoute
  '/_authed/onboarding': typeof AuthedOnboardingRoute
  '/_authed/spotify': typeof AuthedSpotifyRoute
  '/accept-invitation/$invitationId': typeof AcceptInvitationInvitationIdRoute
  '/give/$slug': typeof GiveSlugRoute
  '/preferences/$ref': typeof PreferencesRefRoute
  '/unsubscribe/$ref': typeof UnsubscribeRefRoute
  '/_authed/_shell/attendance': typeof AuthedShellAttendanceRoute
  '/_authed/_shell/checkin': typeof AuthedShellCheckinRoute
  '/_authed/_shell/facilities': typeof AuthedShellFacilitiesRoute
  '/_authed/_shell/giving': typeof AuthedShellGivingRoute
  '/_authed/_shell/my-schedule': typeof AuthedShellMyScheduleRoute
  '/_authed/_shell/reports': typeof AuthedShellReportsRoute
  '/_authed/_shell/settings': typeof AuthedShellSettingsRouteWithChildren
  '/_authed/_shell/tasks': typeof AuthedShellTasksRoute
  '/_authed/admin/ai': typeof AuthedAdminAiRoute
  '/_authed/admin/catalog': typeof AuthedAdminCatalogRoute
  '/_authed/admin/log': typeof AuthedAdminLogRoute
  '/_authed/admin/plans': typeof AuthedAdminPlansRoute
  '/_authed/admin/spotify': typeof AuthedAdminSpotifyRoute
  '/_authed/stand/$planId': typeof AuthedStandPlanIdRoute
  '/_authed/_shell/': typeof AuthedShellIndexRoute
  '/_authed/admin/': typeof AuthedAdminIndexRoute
  '/_authed/_shell/groups/$id': typeof AuthedShellGroupsIdRoute
  '/_authed/_shell/lists/$id': typeof AuthedShellListsIdRoute
  '/_authed/_shell/messages/$id': typeof AuthedShellMessagesIdRoute
  '/_authed/_shell/people/$id': typeof AuthedShellPeopleIdRoute
  '/_authed/_shell/people/duplicates': typeof AuthedShellPeopleDuplicatesRoute
  '/_authed/_shell/people/import': typeof AuthedShellPeopleImportRoute
  '/_authed/_shell/services/_sections': typeof AuthedShellServicesSectionsRouteWithChildren
  '/_authed/_shell/services/shared-teams': typeof AuthedShellServicesSharedTeamsRoute
  '/_authed/_shell/settings/account': typeof AuthedShellSettingsAccountRoute
  '/_authed/_shell/settings/audit-log': typeof AuthedShellSettingsAuditLogRoute
  '/_authed/_shell/settings/billing': typeof AuthedShellSettingsBillingRoute
  '/_authed/_shell/settings/campuses': typeof AuthedShellSettingsCampusesRoute
  '/_authed/_shell/settings/custom-fields': typeof AuthedShellSettingsCustomFieldsRoute
  '/_authed/_shell/settings/developers': typeof AuthedShellSettingsDevelopersRoute
  '/_authed/_shell/settings/group-types': typeof AuthedShellSettingsGroupTypesRoute
  '/_authed/_shell/settings/invitations': typeof AuthedShellSettingsInvitationsRoute
  '/_authed/_shell/settings/planning-center': typeof AuthedShellSettingsPlanningCenterRoute
  '/_authed/_shell/settings/profile': typeof AuthedShellSettingsProfileRoute
  '/_authed/_shell/settings/roles': typeof AuthedShellSettingsRolesRoute
  '/_authed/_shell/settings/services': typeof AuthedShellSettingsServicesRoute
  '/_authed/_shell/settings/staff': typeof AuthedShellSettingsStaffRoute
  '/_authed/_shell/settings/tags': typeof AuthedShellSettingsTagsRoute
  '/_authed/admin/churches/$id': typeof AuthedAdminChurchesIdRoute
  '/_authed/_shell/events/': typeof AuthedShellEventsIndexRoute
  '/_authed/_shell/groups/': typeof AuthedShellGroupsIndexRoute
  '/_authed/_shell/lists/': typeof AuthedShellListsIndexRoute
  '/_authed/_shell/messages/': typeof AuthedShellMessagesIndexRoute
  '/_authed/_shell/people/': typeof AuthedShellPeopleIndexRoute
  '/_authed/_shell/services/': typeof AuthedShellServicesIndexRoute
  '/_authed/_shell/settings/': typeof AuthedShellSettingsIndexRoute
  '/_authed/_shell/events/instances/$id': typeof AuthedShellEventsInstancesIdRoute
  '/_authed/_shell/messages/workflows/$id': typeof AuthedShellMessagesWorkflowsIdRoute
  '/_authed/_shell/services/_sections/schedule': typeof AuthedShellServicesSectionsScheduleRoute
  '/_authed/_shell/services/_sections/teams': typeof AuthedShellServicesSectionsTeamsRoute
  '/_authed/_shell/services/plans/$id': typeof AuthedShellServicesPlansIdRoute
  '/_authed/_shell/services/_sections/people/$personId': typeof AuthedShellServicesSectionsPeoplePersonIdRoute
  '/_authed/_shell/services/_sections/sermons/planner': typeof AuthedShellServicesSectionsSermonsPlannerRoute
  '/_authed/_shell/services/_sections/songs/discover': typeof AuthedShellServicesSectionsSongsDiscoverRoute
  '/_authed/_shell/services/_sections/types/$typeId': typeof AuthedShellServicesSectionsTypesTypeIdRoute
  '/_authed/_shell/services/arrangements/$arrangementId/chart': typeof AuthedShellServicesArrangementsArrangementIdChartRoute
  '/_authed/_shell/services/plans/$id_/sermon': typeof AuthedShellServicesPlansIdSermonRoute
  '/_authed/_shell/services/plans/$id_/suggestions': typeof AuthedShellServicesPlansIdSuggestionsRoute
  '/_authed/_shell/services/types/$typeId/settings': typeof AuthedShellServicesTypesTypeIdSettingsRoute
  '/_authed/_shell/services/_sections/people/': typeof AuthedShellServicesSectionsPeopleIndexRoute
  '/_authed/_shell/services/_sections/plans/': typeof AuthedShellServicesSectionsPlansIndexRoute
  '/_authed/_shell/services/_sections/sermons/': typeof AuthedShellServicesSectionsSermonsIndexRoute
  '/_authed/_shell/services/_sections/songs/': typeof AuthedShellServicesSectionsSongsIndexRoute
  '/_authed/_shell/services/plans/$id_/sermon_/$kind': typeof AuthedShellServicesPlansIdSermonKindRoute
  '/_authed/_shell/services/types/$typeId/templates/$templateId': typeof AuthedShellServicesTypesTypeIdTemplatesTemplateIdRoute
  '/_authed/_shell/services/_sections/songs/$songId/': typeof AuthedShellServicesSectionsSongsSongIdIndexRoute
  '/_authed/_shell/services/types/$typeId/templates/': typeof AuthedShellServicesTypesTypeIdTemplatesIndexRoute
  '/_authed/_shell/services/_sections/songs/$songId/arrangements/$arrangementId': typeof AuthedShellServicesSectionsSongsSongIdArrangementsArrangementIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/kiosk'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/admin'
    | '/apps'
    | '/device'
    | '/onboarding'
    | '/spotify'
    | '/accept-invitation/$invitationId'
    | '/give/$slug'
    | '/preferences/$ref'
    | '/unsubscribe/$ref'
    | '/attendance'
    | '/checkin'
    | '/facilities'
    | '/giving'
    | '/my-schedule'
    | '/reports'
    | '/settings'
    | '/tasks'
    | '/admin/ai'
    | '/admin/catalog'
    | '/admin/log'
    | '/admin/plans'
    | '/admin/spotify'
    | '/stand/$planId'
    | '/admin/'
    | '/groups/$id'
    | '/lists/$id'
    | '/messages/$id'
    | '/people/$id'
    | '/people/duplicates'
    | '/people/import'
    | '/services'
    | '/services/shared-teams'
    | '/settings/account'
    | '/settings/audit-log'
    | '/settings/billing'
    | '/settings/campuses'
    | '/settings/custom-fields'
    | '/settings/developers'
    | '/settings/group-types'
    | '/settings/invitations'
    | '/settings/planning-center'
    | '/settings/profile'
    | '/settings/roles'
    | '/settings/services'
    | '/settings/staff'
    | '/settings/tags'
    | '/admin/churches/$id'
    | '/events/'
    | '/groups/'
    | '/lists/'
    | '/messages/'
    | '/people/'
    | '/services/'
    | '/settings/'
    | '/events/instances/$id'
    | '/messages/workflows/$id'
    | '/services/schedule'
    | '/services/teams'
    | '/services/plans/$id'
    | '/services/people/$personId'
    | '/services/sermons/planner'
    | '/services/songs/discover'
    | '/services/types/$typeId'
    | '/services/arrangements/$arrangementId/chart'
    | '/services/plans/$id/sermon'
    | '/services/plans/$id/suggestions'
    | '/services/types/$typeId/settings'
    | '/services/people/'
    | '/services/plans/'
    | '/services/sermons/'
    | '/services/songs/'
    | '/services/plans/$id/sermon/$kind'
    | '/services/types/$typeId/templates/$templateId'
    | '/services/songs/$songId/'
    | '/services/types/$typeId/templates/'
    | '/services/songs/$songId/arrangements/$arrangementId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/kiosk'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/apps'
    | '/device'
    | '/onboarding'
    | '/spotify'
    | '/accept-invitation/$invitationId'
    | '/give/$slug'
    | '/preferences/$ref'
    | '/unsubscribe/$ref'
    | '/attendance'
    | '/checkin'
    | '/facilities'
    | '/giving'
    | '/my-schedule'
    | '/reports'
    | '/tasks'
    | '/admin/ai'
    | '/admin/catalog'
    | '/admin/log'
    | '/admin/plans'
    | '/admin/spotify'
    | '/stand/$planId'
    | '/admin'
    | '/groups/$id'
    | '/lists/$id'
    | '/messages/$id'
    | '/people/$id'
    | '/people/duplicates'
    | '/people/import'
    | '/services'
    | '/services/shared-teams'
    | '/settings/account'
    | '/settings/audit-log'
    | '/settings/billing'
    | '/settings/campuses'
    | '/settings/custom-fields'
    | '/settings/developers'
    | '/settings/group-types'
    | '/settings/invitations'
    | '/settings/planning-center'
    | '/settings/profile'
    | '/settings/roles'
    | '/settings/services'
    | '/settings/staff'
    | '/settings/tags'
    | '/admin/churches/$id'
    | '/events'
    | '/groups'
    | '/lists'
    | '/messages'
    | '/people'
    | '/settings'
    | '/events/instances/$id'
    | '/messages/workflows/$id'
    | '/services/schedule'
    | '/services/teams'
    | '/services/plans/$id'
    | '/services/people/$personId'
    | '/services/sermons/planner'
    | '/services/songs/discover'
    | '/services/types/$typeId'
    | '/services/arrangements/$arrangementId/chart'
    | '/services/plans/$id/sermon'
    | '/services/plans/$id/suggestions'
    | '/services/types/$typeId/settings'
    | '/services/people'
    | '/services/plans'
    | '/services/sermons'
    | '/services/songs'
    | '/services/plans/$id/sermon/$kind'
    | '/services/types/$typeId/templates/$templateId'
    | '/services/songs/$songId'
    | '/services/types/$typeId/templates'
    | '/services/songs/$songId/arrangements/$arrangementId'
  id:
    | '__root__'
    | '/_auth'
    | '/_authed'
    | '/kiosk'
    | '/_auth/forgot-password'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/_authed/_shell'
    | '/_authed/admin'
    | '/_authed/apps'
    | '/_authed/device'
    | '/_authed/onboarding'
    | '/_authed/spotify'
    | '/accept-invitation/$invitationId'
    | '/give/$slug'
    | '/preferences/$ref'
    | '/unsubscribe/$ref'
    | '/_authed/_shell/attendance'
    | '/_authed/_shell/checkin'
    | '/_authed/_shell/facilities'
    | '/_authed/_shell/giving'
    | '/_authed/_shell/my-schedule'
    | '/_authed/_shell/reports'
    | '/_authed/_shell/settings'
    | '/_authed/_shell/tasks'
    | '/_authed/admin/ai'
    | '/_authed/admin/catalog'
    | '/_authed/admin/log'
    | '/_authed/admin/plans'
    | '/_authed/admin/spotify'
    | '/_authed/stand/$planId'
    | '/_authed/_shell/'
    | '/_authed/admin/'
    | '/_authed/_shell/groups/$id'
    | '/_authed/_shell/lists/$id'
    | '/_authed/_shell/messages/$id'
    | '/_authed/_shell/people/$id'
    | '/_authed/_shell/people/duplicates'
    | '/_authed/_shell/people/import'
    | '/_authed/_shell/services/_sections'
    | '/_authed/_shell/services/shared-teams'
    | '/_authed/_shell/settings/account'
    | '/_authed/_shell/settings/audit-log'
    | '/_authed/_shell/settings/billing'
    | '/_authed/_shell/settings/campuses'
    | '/_authed/_shell/settings/custom-fields'
    | '/_authed/_shell/settings/developers'
    | '/_authed/_shell/settings/group-types'
    | '/_authed/_shell/settings/invitations'
    | '/_authed/_shell/settings/planning-center'
    | '/_authed/_shell/settings/profile'
    | '/_authed/_shell/settings/roles'
    | '/_authed/_shell/settings/services'
    | '/_authed/_shell/settings/staff'
    | '/_authed/_shell/settings/tags'
    | '/_authed/admin/churches/$id'
    | '/_authed/_shell/events/'
    | '/_authed/_shell/groups/'
    | '/_authed/_shell/lists/'
    | '/_authed/_shell/messages/'
    | '/_authed/_shell/people/'
    | '/_authed/_shell/services/'
    | '/_authed/_shell/settings/'
    | '/_authed/_shell/events/instances/$id'
    | '/_authed/_shell/messages/workflows/$id'
    | '/_authed/_shell/services/_sections/schedule'
    | '/_authed/_shell/services/_sections/teams'
    | '/_authed/_shell/services/plans/$id'
    | '/_authed/_shell/services/_sections/people/$personId'
    | '/_authed/_shell/services/_sections/sermons/planner'
    | '/_authed/_shell/services/_sections/songs/discover'
    | '/_authed/_shell/services/_sections/types/$typeId'
    | '/_authed/_shell/services/arrangements/$arrangementId/chart'
    | '/_authed/_shell/services/plans/$id_/sermon'
    | '/_authed/_shell/services/plans/$id_/suggestions'
    | '/_authed/_shell/services/types/$typeId/settings'
    | '/_authed/_shell/services/_sections/people/'
    | '/_authed/_shell/services/_sections/plans/'
    | '/_authed/_shell/services/_sections/sermons/'
    | '/_authed/_shell/services/_sections/songs/'
    | '/_authed/_shell/services/plans/$id_/sermon_/$kind'
    | '/_authed/_shell/services/types/$typeId/templates/$templateId'
    | '/_authed/_shell/services/_sections/songs/$songId/'
    | '/_authed/_shell/services/types/$typeId/templates/'
    | '/_authed/_shell/services/_sections/songs/$songId/arrangements/$arrangementId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  AuthedRoute: typeof AuthedRouteWithChildren
  KioskRoute: typeof KioskRoute
  AcceptInvitationInvitationIdRoute: typeof AcceptInvitationInvitationIdRoute
  GiveSlugRoute: typeof GiveSlugRoute
  PreferencesRefRoute: typeof PreferencesRefRoute
  UnsubscribeRefRoute: typeof UnsubscribeRefRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kiosk': {
      id: '/kiosk'
      path: '/kiosk'
      fullPath: '/kiosk'
      preLoaderRoute: typeof KioskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authed/_shell': {
      id: '/_authed/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedShellRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin': {
      id: '/_authed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/apps': {
      id: '/_authed/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AuthedAppsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/device': {
      id: '/_authed/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof AuthedDeviceRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/onboarding': {
      id: '/_authed/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthedOnboardingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/spotify': {
      id: '/_authed/spotify'
      path: '/spotify'
      fullPath: '/spotify'
      preLoaderRoute: typeof AuthedSpotifyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/accept-invitation/$invitationId': {
      id: '/accept-invitation/$invitationId'
      path: '/accept-invitation/$invitationId'
      fullPath: '/accept-invitation/$invitationId'
      preLoaderRoute: typeof AcceptInvitationInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/give/$slug': {
      id: '/give/$slug'
      path: '/give/$slug'
      fullPath: '/give/$slug'
      preLoaderRoute: typeof GiveSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preferences/$ref': {
      id: '/preferences/$ref'
      path: '/preferences/$ref'
      fullPath: '/preferences/$ref'
      preLoaderRoute: typeof PreferencesRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe/$ref': {
      id: '/unsubscribe/$ref'
      path: '/unsubscribe/$ref'
      fullPath: '/unsubscribe/$ref'
      preLoaderRoute: typeof UnsubscribeRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/_shell/': {
      id: '/_authed/_shell/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedShellIndexRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/attendance': {
      id: '/_authed/_shell/attendance'
      path: '/attendance'
      fullPath: '/attendance'
      preLoaderRoute: typeof AuthedShellAttendanceRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/checkin': {
      id: '/_authed/_shell/checkin'
      path: '/checkin'
      fullPath: '/checkin'
      preLoaderRoute: typeof AuthedShellCheckinRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/facilities': {
      id: '/_authed/_shell/facilities'
      path: '/facilities'
      fullPath: '/facilities'
      preLoaderRoute: typeof AuthedShellFacilitiesRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/giving': {
      id: '/_authed/_shell/giving'
      path: '/giving'
      fullPath: '/giving'
      preLoaderRoute: typeof AuthedShellGivingRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/my-schedule': {
      id: '/_authed/_shell/my-schedule'
      path: '/my-schedule'
      fullPath: '/my-schedule'
      preLoaderRoute: typeof AuthedShellMyScheduleRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/reports': {
      id: '/_authed/_shell/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthedShellReportsRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/settings': {
      id: '/_authed/_shell/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedShellSettingsRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/tasks': {
      id: '/_authed/_shell/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthedShellTasksRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/admin/': {
      id: '/_authed/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedAdminIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/ai': {
      id: '/_authed/admin/ai'
      path: '/ai'
      fullPath: '/admin/ai'
      preLoaderRoute: typeof AuthedAdminAiRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/catalog': {
      id: '/_authed/admin/catalog'
      path: '/catalog'
      fullPath: '/admin/catalog'
      preLoaderRoute: typeof AuthedAdminCatalogRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/log': {
      id: '/_authed/admin/log'
      path: '/log'
      fullPath: '/admin/log'
      preLoaderRoute: typeof AuthedAdminLogRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/plans': {
      id: '/_authed/admin/plans'
      path: '/plans'
      fullPath: '/admin/plans'
      preLoaderRoute: typeof AuthedAdminPlansRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/spotify': {
      id: '/_authed/admin/spotify'
      path: '/spotify'
      fullPath: '/admin/spotify'
      preLoaderRoute: typeof AuthedAdminSpotifyRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/stand/$planId': {
      id: '/_authed/stand/$planId'
      path: '/stand/$planId'
      fullPath: '/stand/$planId'
      preLoaderRoute: typeof AuthedStandPlanIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_shell/events/': {
      id: '/_authed/_shell/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof AuthedShellEventsIndexRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/groups/': {
      id: '/_authed/_shell/groups/'
      path: '/groups'
      fullPath: '/groups/'
      preLoaderRoute: typeof AuthedShellGroupsIndexRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/groups/$id': {
      id: '/_authed/_shell/groups/$id'
      path: '/groups/$id'
      fullPath: '/groups/$id'
      preLoaderRoute: typeof AuthedShellGroupsIdRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/lists/': {
      id: '/_authed/_shell/lists/'
      path: '/lists'
      fullPath: '/lists/'
      preLoaderRoute: typeof AuthedShellListsIndexRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/lists/$id': {
      id: '/_authed/_shell/lists/$id'
      path: '/lists/$id'
      fullPath: '/lists/$id'
      preLoaderRoute: typeof AuthedShellListsIdRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/messages/': {
      id: '/_authed/_shell/messages/'
      path: '/messages'
      fullPath: '/messages/'
      preLoaderRoute: typeof AuthedShellMessagesIndexRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/messages/$id': {
      id: '/_authed/_shell/messages/$id'
      path: '/messages/$id'
      fullPath: '/messages/$id'
      preLoaderRoute: typeof AuthedShellMessagesIdRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/people/': {
      id: '/_authed/_shell/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof AuthedShellPeopleIndexRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/people/$id': {
      id: '/_authed/_shell/people/$id'
      path: '/people/$id'
      fullPath: '/people/$id'
      preLoaderRoute: typeof AuthedShellPeopleIdRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/people/duplicates': {
      id: '/_authed/_shell/people/duplicates'
      path: '/people/duplicates'
      fullPath: '/people/duplicates'
      preLoaderRoute: typeof AuthedShellPeopleDuplicatesRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/people/import': {
      id: '/_authed/_shell/people/import'
      path: '/people/import'
      fullPath: '/people/import'
      preLoaderRoute: typeof AuthedShellPeopleImportRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/services/': {
      id: '/_authed/_shell/services/'
      path: '/services'
      fullPath: '/services/'
      preLoaderRoute: typeof AuthedShellServicesIndexRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/services/_sections': {
      id: '/_authed/_shell/services/_sections'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof AuthedShellServicesSectionsRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/services/shared-teams': {
      id: '/_authed/_shell/services/shared-teams'
      path: '/services/shared-teams'
      fullPath: '/services/shared-teams'
      preLoaderRoute: typeof AuthedShellServicesSharedTeamsRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/settings/': {
      id: '/_authed/_shell/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthedShellSettingsIndexRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/_shell/settings/account': {
      id: '/_authed/_shell/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthedShellSettingsAccountRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/_shell/settings/audit-log': {
      id: '/_authed/_shell/settings/audit-log'
      path: '/audit-log'
      fullPath: '/settings/audit-log'
      preLoaderRoute: typeof AuthedShellSettingsAuditLogRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/_shell/settings/billing': {
      id: '/_authed/_shell/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthedShellSettingsBillingRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/_shell/settings/campuses': {
      id: '/_authed/_shell/settings/campuses'
      path: '/campuses'
      fullPath: '/settings/campuses'
      preLoaderRoute: typeof AuthedShellSettingsCampusesRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/_shell/settings/custom-fields': {
      id: '/_authed/_shell/settings/custom-fields'
      path: '/custom-fields'
      fullPath: '/settings/custom-fields'
      preLoaderRoute: typeof AuthedShellSettingsCustomFieldsRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/_shell/settings/developers': {
      id: '/_authed/_shell/settings/developers'
      path: '/developers'
      fullPath: '/settings/developers'
      preLoaderRoute: typeof AuthedShellSettingsDevelopersRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/_shell/settings/group-types': {
      id: '/_authed/_shell/settings/group-types'
      path: '/group-types'
      fullPath: '/settings/group-types'
      preLoaderRoute: typeof AuthedShellSettingsGroupTypesRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/_shell/settings/invitations': {
      id: '/_authed/_shell/settings/invitations'
      path: '/invitations'
      fullPath: '/settings/invitations'
      preLoaderRoute: typeof AuthedShellSettingsInvitationsRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/_shell/settings/planning-center': {
      id: '/_authed/_shell/settings/planning-center'
      path: '/planning-center'
      fullPath: '/settings/planning-center'
      preLoaderRoute: typeof AuthedShellSettingsPlanningCenterRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/_shell/settings/profile': {
      id: '/_authed/_shell/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthedShellSettingsProfileRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/_shell/settings/roles': {
      id: '/_authed/_shell/settings/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AuthedShellSettingsRolesRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/_shell/settings/services': {
      id: '/_authed/_shell/settings/services'
      path: '/services'
      fullPath: '/settings/services'
      preLoaderRoute: typeof AuthedShellSettingsServicesRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/_shell/settings/staff': {
      id: '/_authed/_shell/settings/staff'
      path: '/staff'
      fullPath: '/settings/staff'
      preLoaderRoute: typeof AuthedShellSettingsStaffRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/_shell/settings/tags': {
      id: '/_authed/_shell/settings/tags'
      path: '/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof AuthedShellSettingsTagsRouteImport
      parentRoute: typeof AuthedShellSettingsRoute
    }
    '/_authed/admin/churches/$id': {
      id: '/_authed/admin/churches/$id'
      path: '/churches/$id'
      fullPath: '/admin/churches/$id'
      preLoaderRoute: typeof AuthedAdminChurchesIdRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_shell/events/instances/$id': {
      id: '/_authed/_shell/events/instances/$id'
      path: '/events/instances/$id'
      fullPath: '/events/instances/$id'
      preLoaderRoute: typeof AuthedShellEventsInstancesIdRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/messages/workflows/$id': {
      id: '/_authed/_shell/messages/workflows/$id'
      path: '/messages/workflows/$id'
      fullPath: '/messages/workflows/$id'
      preLoaderRoute: typeof AuthedShellMessagesWorkflowsIdRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/services/_sections/schedule': {
      id: '/_authed/_shell/services/_sections/schedule'
      path: '/schedule'
      fullPath: '/services/schedule'
      preLoaderRoute: typeof AuthedShellServicesSectionsScheduleRouteImport
      parentRoute: typeof AuthedShellServicesSectionsRoute
    }
    '/_authed/_shell/services/_sections/teams': {
      id: '/_authed/_shell/services/_sections/teams'
      path: '/teams'
      fullPath: '/services/teams'
      preLoaderRoute: typeof AuthedShellServicesSectionsTeamsRouteImport
      parentRoute: typeof AuthedShellServicesSectionsRoute
    }
    '/_authed/_shell/services/plans/$id': {
      id: '/_authed/_shell/services/plans/$id'
      path: '/services/plans/$id'
      fullPath: '/services/plans/$id'
      preLoaderRoute: typeof AuthedShellServicesPlansIdRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/services/_sections/people/': {
      id: '/_authed/_shell/services/_sections/people/'
      path: '/people'
      fullPath: '/services/people/'
      preLoaderRoute: typeof AuthedShellServicesSectionsPeopleIndexRouteImport
      parentRoute: typeof AuthedShellServicesSectionsRoute
    }
    '/_authed/_shell/services/_sections/people/$personId': {
      id: '/_authed/_shell/services/_sections/people/$personId'
      path: '/people/$personId'
      fullPath: '/services/people/$personId'
      preLoaderRoute: typeof AuthedShellServicesSectionsPeoplePersonIdRouteImport
      parentRoute: typeof AuthedShellServicesSectionsRoute
    }
    '/_authed/_shell/services/_sections/plans/': {
      id: '/_authed/_shell/services/_sections/plans/'
      path: '/plans'
      fullPath: '/services/plans/'
      preLoaderRoute: typeof AuthedShellServicesSectionsPlansIndexRouteImport
      parentRoute: typeof AuthedShellServicesSectionsRoute
    }
    '/_authed/_shell/services/_sections/sermons/': {
      id: '/_authed/_shell/services/_sections/sermons/'
      path: '/sermons'
      fullPath: '/services/sermons/'
      preLoaderRoute: typeof AuthedShellServicesSectionsSermonsIndexRouteImport
      parentRoute: typeof AuthedShellServicesSectionsRoute
    }
    '/_authed/_shell/services/_sections/sermons/planner': {
      id: '/_authed/_shell/services/_sections/sermons/planner'
      path: '/sermons/planner'
      fullPath: '/services/sermons/planner'
      preLoaderRoute: typeof AuthedShellServicesSectionsSermonsPlannerRouteImport
      parentRoute: typeof AuthedShellServicesSectionsRoute
    }
    '/_authed/_shell/services/_sections/songs/': {
      id: '/_authed/_shell/services/_sections/songs/'
      path: '/songs'
      fullPath: '/services/songs/'
      preLoaderRoute: typeof AuthedShellServicesSectionsSongsIndexRouteImport
      parentRoute: typeof AuthedShellServicesSectionsRoute
    }
    '/_authed/_shell/services/_sections/songs/discover': {
      id: '/_authed/_shell/services/_sections/songs/discover'
      path: '/songs/discover'
      fullPath: '/services/songs/discover'
      preLoaderRoute: typeof AuthedShellServicesSectionsSongsDiscoverRouteImport
      parentRoute: typeof AuthedShellServicesSectionsRoute
    }
    '/_authed/_shell/services/_sections/types/$typeId': {
      id: '/_authed/_shell/services/_sections/types/$typeId'
      path: '/types/$typeId'
      fullPath: '/services/types/$typeId'
      preLoaderRoute: typeof AuthedShellServicesSectionsTypesTypeIdRouteImport
      parentRoute: typeof AuthedShellServicesSectionsRoute
    }
    '/_authed/_shell/services/arrangements/$arrangementId/chart': {
      id: '/_authed/_shell/services/arrangements/$arrangementId/chart'
      path: '/services/arrangements/$arrangementId/chart'
      fullPath: '/services/arrangements/$arrangementId/chart'
      preLoaderRoute: typeof AuthedShellServicesArrangementsArrangementIdChartRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/services/plans/$id_/sermon': {
      id: '/_authed/_shell/services/plans/$id_/sermon'
      path: '/services/plans/$id/sermon'
      fullPath: '/services/plans/$id/sermon'
      preLoaderRoute: typeof AuthedShellServicesPlansIdSermonRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/services/plans/$id_/suggestions': {
      id: '/_authed/_shell/services/plans/$id_/suggestions'
      path: '/services/plans/$id/suggestions'
      fullPath: '/services/plans/$id/suggestions'
      preLoaderRoute: typeof AuthedShellServicesPlansIdSuggestionsRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/services/types/$typeId/settings': {
      id: '/_authed/_shell/services/types/$typeId/settings'
      path: '/services/types/$typeId/settings'
      fullPath: '/services/types/$typeId/settings'
      preLoaderRoute: typeof AuthedShellServicesTypesTypeIdSettingsRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/services/_sections/songs/$songId/': {
      id: '/_authed/_shell/services/_sections/songs/$songId/'
      path: '/songs/$songId'
      fullPath: '/services/songs/$songId/'
      preLoaderRoute: typeof AuthedShellServicesSectionsSongsSongIdIndexRouteImport
      parentRoute: typeof AuthedShellServicesSectionsRoute
    }
    '/_authed/_shell/services/plans/$id_/sermon_/$kind': {
      id: '/_authed/_shell/services/plans/$id_/sermon_/$kind'
      path: '/services/plans/$id/sermon/$kind'
      fullPath: '/services/plans/$id/sermon/$kind'
      preLoaderRoute: typeof AuthedShellServicesPlansIdSermonKindRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/services/types/$typeId/templates/': {
      id: '/_authed/_shell/services/types/$typeId/templates/'
      path: '/services/types/$typeId/templates'
      fullPath: '/services/types/$typeId/templates/'
      preLoaderRoute: typeof AuthedShellServicesTypesTypeIdTemplatesIndexRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/services/types/$typeId/templates/$templateId': {
      id: '/_authed/_shell/services/types/$typeId/templates/$templateId'
      path: '/services/types/$typeId/templates/$templateId'
      fullPath: '/services/types/$typeId/templates/$templateId'
      preLoaderRoute: typeof AuthedShellServicesTypesTypeIdTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/services/_sections/songs/$songId/arrangements/$arrangementId': {
      id: '/_authed/_shell/services/_sections/songs/$songId/arrangements/$arrangementId'
      path: '/songs/$songId/arrangements/$arrangementId'
      fullPath: '/services/songs/$songId/arrangements/$arrangementId'
      preLoaderRoute: typeof AuthedShellServicesSectionsSongsSongIdArrangementsArrangementIdRouteImport
      parentRoute: typeof AuthedShellServicesSectionsRoute
    }
  }
}

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthedShellSettingsRouteChildren {
  AuthedShellSettingsAccountRoute: typeof AuthedShellSettingsAccountRoute
  AuthedShellSettingsAuditLogRoute: typeof AuthedShellSettingsAuditLogRoute
  AuthedShellSettingsBillingRoute: typeof AuthedShellSettingsBillingRoute
  AuthedShellSettingsCampusesRoute: typeof AuthedShellSettingsCampusesRoute
  AuthedShellSettingsCustomFieldsRoute: typeof AuthedShellSettingsCustomFieldsRoute
  AuthedShellSettingsDevelopersRoute: typeof AuthedShellSettingsDevelopersRoute
  AuthedShellSettingsGroupTypesRoute: typeof AuthedShellSettingsGroupTypesRoute
  AuthedShellSettingsInvitationsRoute: typeof AuthedShellSettingsInvitationsRoute
  AuthedShellSettingsPlanningCenterRoute: typeof AuthedShellSettingsPlanningCenterRoute
  AuthedShellSettingsProfileRoute: typeof AuthedShellSettingsProfileRoute
  AuthedShellSettingsRolesRoute: typeof AuthedShellSettingsRolesRoute
  AuthedShellSettingsServicesRoute: typeof AuthedShellSettingsServicesRoute
  AuthedShellSettingsStaffRoute: typeof AuthedShellSettingsStaffRoute
  AuthedShellSettingsTagsRoute: typeof AuthedShellSettingsTagsRoute
  AuthedShellSettingsIndexRoute: typeof AuthedShellSettingsIndexRoute
}

const AuthedShellSettingsRouteChildren: AuthedShellSettingsRouteChildren = {
  AuthedShellSettingsAccountRoute: AuthedShellSettingsAccountRoute,
  AuthedShellSettingsAuditLogRoute: AuthedShellSettingsAuditLogRoute,
  AuthedShellSettingsBillingRoute: AuthedShellSettingsBillingRoute,
  AuthedShellSettingsCampusesRoute: AuthedShellSettingsCampusesRoute,
  AuthedShellSettingsCustomFieldsRoute: AuthedShellSettingsCustomFieldsRoute,
  AuthedShellSettingsDevelopersRoute: AuthedShellSettingsDevelopersRoute,
  AuthedShellSettingsGroupTypesRoute: AuthedShellSettingsGroupTypesRoute,
  AuthedShellSettingsInvitationsRoute: AuthedShellSettingsInvitationsRoute,
  AuthedShellSettingsPlanningCenterRoute:
    AuthedShellSettingsPlanningCenterRoute,
  AuthedShellSettingsProfileRoute: AuthedShellSettingsProfileRoute,
  AuthedShellSettingsRolesRoute: AuthedShellSettingsRolesRoute,
  AuthedShellSettingsServicesRoute: AuthedShellSettingsServicesRoute,
  AuthedShellSettingsStaffRoute: AuthedShellSettingsStaffRoute,
  AuthedShellSettingsTagsRoute: AuthedShellSettingsTagsRoute,
  AuthedShellSettingsIndexRoute: AuthedShellSettingsIndexRoute,
}

const AuthedShellSettingsRouteWithChildren =
  AuthedShellSettingsRoute._addFileChildren(AuthedShellSettingsRouteChildren)

interface AuthedShellServicesSectionsRouteChildren {
  AuthedShellServicesSectionsScheduleRoute: typeof AuthedShellServicesSectionsScheduleRoute
  AuthedShellServicesSectionsTeamsRoute: typeof AuthedShellServicesSectionsTeamsRoute
  AuthedShellServicesSectionsPeoplePersonIdRoute: typeof AuthedShellServicesSectionsPeoplePersonIdRoute
  AuthedShellServicesSectionsSermonsPlannerRoute: typeof AuthedShellServicesSectionsSermonsPlannerRoute
  AuthedShellServicesSectionsSongsDiscoverRoute: typeof AuthedShellServicesSectionsSongsDiscoverRoute
  AuthedShellServicesSectionsTypesTypeIdRoute: typeof AuthedShellServicesSectionsTypesTypeIdRoute
  AuthedShellServicesSectionsPeopleIndexRoute: typeof AuthedShellServicesSectionsPeopleIndexRoute
  AuthedShellServicesSectionsPlansIndexRoute: typeof AuthedShellServicesSectionsPlansIndexRoute
  AuthedShellServicesSectionsSermonsIndexRoute: typeof AuthedShellServicesSectionsSermonsIndexRoute
  AuthedShellServicesSectionsSongsIndexRoute: typeof AuthedShellServicesSectionsSongsIndexRoute
  AuthedShellServicesSectionsSongsSongIdIndexRoute: typeof AuthedShellServicesSectionsSongsSongIdIndexRoute
  AuthedShellServicesSectionsSongsSongIdArrangementsArrangementIdRoute: typeof AuthedShellServicesSectionsSongsSongIdArrangementsArrangementIdRoute
}

const AuthedShellServicesSectionsRouteChildren: AuthedShellServicesSectionsRouteChildren =
  {
    AuthedShellServicesSectionsScheduleRoute:
      AuthedShellServicesSectionsScheduleRoute,
    AuthedShellServicesSectionsTeamsRoute:
      AuthedShellServicesSectionsTeamsRoute,
    AuthedShellServicesSectionsPeoplePersonIdRoute:
      AuthedShellServicesSectionsPeoplePersonIdRoute,
    AuthedShellServicesSectionsSermonsPlannerRoute:
      AuthedShellServicesSectionsSermonsPlannerRoute,
    AuthedShellServicesSectionsSongsDiscoverRoute:
      AuthedShellServicesSectionsSongsDiscoverRoute,
    AuthedShellServicesSectionsTypesTypeIdRoute:
      AuthedShellServicesSectionsTypesTypeIdRoute,
    AuthedShellServicesSectionsPeopleIndexRoute:
      AuthedShellServicesSectionsPeopleIndexRoute,
    AuthedShellServicesSectionsPlansIndexRoute:
      AuthedShellServicesSectionsPlansIndexRoute,
    AuthedShellServicesSectionsSermonsIndexRoute:
      AuthedShellServicesSectionsSermonsIndexRoute,
    AuthedShellServicesSectionsSongsIndexRoute:
      AuthedShellServicesSectionsSongsIndexRoute,
    AuthedShellServicesSectionsSongsSongIdIndexRoute:
      AuthedShellServicesSectionsSongsSongIdIndexRoute,
    AuthedShellServicesSectionsSongsSongIdArrangementsArrangementIdRoute:
      AuthedShellServicesSectionsSongsSongIdArrangementsArrangementIdRoute,
  }

const AuthedShellServicesSectionsRouteWithChildren =
  AuthedShellServicesSectionsRoute._addFileChildren(
    AuthedShellServicesSectionsRouteChildren,
  )

interface AuthedShellRouteChildren {
  AuthedShellAttendanceRoute: typeof AuthedShellAttendanceRoute
  AuthedShellCheckinRoute: typeof AuthedShellCheckinRoute
  AuthedShellFacilitiesRoute: typeof AuthedShellFacilitiesRoute
  AuthedShellGivingRoute: typeof AuthedShellGivingRoute
  AuthedShellMyScheduleRoute: typeof AuthedShellMyScheduleRoute
  AuthedShellReportsRoute: typeof AuthedShellReportsRoute
  AuthedShellSettingsRoute: typeof AuthedShellSettingsRouteWithChildren
  AuthedShellTasksRoute: typeof AuthedShellTasksRoute
  AuthedShellIndexRoute: typeof AuthedShellIndexRoute
  AuthedShellGroupsIdRoute: typeof AuthedShellGroupsIdRoute
  AuthedShellListsIdRoute: typeof AuthedShellListsIdRoute
  AuthedShellMessagesIdRoute: typeof AuthedShellMessagesIdRoute
  AuthedShellPeopleIdRoute: typeof AuthedShellPeopleIdRoute
  AuthedShellPeopleDuplicatesRoute: typeof AuthedShellPeopleDuplicatesRoute
  AuthedShellPeopleImportRoute: typeof AuthedShellPeopleImportRoute
  AuthedShellServicesSectionsRoute: typeof AuthedShellServicesSectionsRouteWithChildren
  AuthedShellServicesSharedTeamsRoute: typeof AuthedShellServicesSharedTeamsRoute
  AuthedShellEventsIndexRoute: typeof AuthedShellEventsIndexRoute
  AuthedShellGroupsIndexRoute: typeof AuthedShellGroupsIndexRoute
  AuthedShellListsIndexRoute: typeof AuthedShellListsIndexRoute
  AuthedShellMessagesIndexRoute: typeof AuthedShellMessagesIndexRoute
  AuthedShellPeopleIndexRoute: typeof AuthedShellPeopleIndexRoute
  AuthedShellServicesIndexRoute: typeof AuthedShellServicesIndexRoute
  AuthedShellEventsInstancesIdRoute: typeof AuthedShellEventsInstancesIdRoute
  AuthedShellMessagesWorkflowsIdRoute: typeof AuthedShellMessagesWorkflowsIdRoute
  AuthedShellServicesPlansIdRoute: typeof AuthedShellServicesPlansIdRoute
  AuthedShellServicesArrangementsArrangementIdChartRoute: typeof AuthedShellServicesArrangementsArrangementIdChartRoute
  AuthedShellServicesPlansIdSermonRoute: typeof AuthedShellServicesPlansIdSermonRoute
  AuthedShellServicesPlansIdSuggestionsRoute: typeof AuthedShellServicesPlansIdSuggestionsRoute
  AuthedShellServicesTypesTypeIdSettingsRoute: typeof AuthedShellServicesTypesTypeIdSettingsRoute
  AuthedShellServicesPlansIdSermonKindRoute: typeof AuthedShellServicesPlansIdSermonKindRoute
  AuthedShellServicesTypesTypeIdTemplatesTemplateIdRoute: typeof AuthedShellServicesTypesTypeIdTemplatesTemplateIdRoute
  AuthedShellServicesTypesTypeIdTemplatesIndexRoute: typeof AuthedShellServicesTypesTypeIdTemplatesIndexRoute
}

const AuthedShellRouteChildren: AuthedShellRouteChildren = {
  AuthedShellAttendanceRoute: AuthedShellAttendanceRoute,
  AuthedShellCheckinRoute: AuthedShellCheckinRoute,
  AuthedShellFacilitiesRoute: AuthedShellFacilitiesRoute,
  AuthedShellGivingRoute: AuthedShellGivingRoute,
  AuthedShellMyScheduleRoute: AuthedShellMyScheduleRoute,
  AuthedShellReportsRoute: AuthedShellReportsRoute,
  AuthedShellSettingsRoute: AuthedShellSettingsRouteWithChildren,
  AuthedShellTasksRoute: AuthedShellTasksRoute,
  AuthedShellIndexRoute: AuthedShellIndexRoute,
  AuthedShellGroupsIdRoute: AuthedShellGroupsIdRoute,
  AuthedShellListsIdRoute: AuthedShellListsIdRoute,
  AuthedShellMessagesIdRoute: AuthedShellMessagesIdRoute,
  AuthedShellPeopleIdRoute: AuthedShellPeopleIdRoute,
  AuthedShellPeopleDuplicatesRoute: AuthedShellPeopleDuplicatesRoute,
  AuthedShellPeopleImportRoute: AuthedShellPeopleImportRoute,
  AuthedShellServicesSectionsRoute:
    AuthedShellServicesSectionsRouteWithChildren,
  AuthedShellServicesSharedTeamsRoute: AuthedShellServicesSharedTeamsRoute,
  AuthedShellEventsIndexRoute: AuthedShellEventsIndexRoute,
  AuthedShellGroupsIndexRoute: AuthedShellGroupsIndexRoute,
  AuthedShellListsIndexRoute: AuthedShellListsIndexRoute,
  AuthedShellMessagesIndexRoute: AuthedShellMessagesIndexRoute,
  AuthedShellPeopleIndexRoute: AuthedShellPeopleIndexRoute,
  AuthedShellServicesIndexRoute: AuthedShellServicesIndexRoute,
  AuthedShellEventsInstancesIdRoute: AuthedShellEventsInstancesIdRoute,
  AuthedShellMessagesWorkflowsIdRoute: AuthedShellMessagesWorkflowsIdRoute,
  AuthedShellServicesPlansIdRoute: AuthedShellServicesPlansIdRoute,
  AuthedShellServicesArrangementsArrangementIdChartRoute:
    AuthedShellServicesArrangementsArrangementIdChartRoute,
  AuthedShellServicesPlansIdSermonRoute: AuthedShellServicesPlansIdSermonRoute,
  AuthedShellServicesPlansIdSuggestionsRoute:
    AuthedShellServicesPlansIdSuggestionsRoute,
  AuthedShellServicesTypesTypeIdSettingsRoute:
    AuthedShellServicesTypesTypeIdSettingsRoute,
  AuthedShellServicesPlansIdSermonKindRoute:
    AuthedShellServicesPlansIdSermonKindRoute,
  AuthedShellServicesTypesTypeIdTemplatesTemplateIdRoute:
    AuthedShellServicesTypesTypeIdTemplatesTemplateIdRoute,
  AuthedShellServicesTypesTypeIdTemplatesIndexRoute:
    AuthedShellServicesTypesTypeIdTemplatesIndexRoute,
}

const AuthedShellRouteWithChildren = AuthedShellRoute._addFileChildren(
  AuthedShellRouteChildren,
)

interface AuthedAdminRouteChildren {
  AuthedAdminAiRoute: typeof AuthedAdminAiRoute
  AuthedAdminCatalogRoute: typeof AuthedAdminCatalogRoute
  AuthedAdminLogRoute: typeof AuthedAdminLogRoute
  AuthedAdminPlansRoute: typeof AuthedAdminPlansRoute
  AuthedAdminSpotifyRoute: typeof AuthedAdminSpotifyRoute
  AuthedAdminIndexRoute: typeof AuthedAdminIndexRoute
  AuthedAdminChurchesIdRoute: typeof AuthedAdminChurchesIdRoute
}

const AuthedAdminRouteChildren: AuthedAdminRouteChildren = {
  AuthedAdminAiRoute: AuthedAdminAiRoute,
  AuthedAdminCatalogRoute: AuthedAdminCatalogRoute,
  AuthedAdminLogRoute: AuthedAdminLogRoute,
  AuthedAdminPlansRoute: AuthedAdminPlansRoute,
  AuthedAdminSpotifyRoute: AuthedAdminSpotifyRoute,
  AuthedAdminIndexRoute: AuthedAdminIndexRoute,
  AuthedAdminChurchesIdRoute: AuthedAdminChurchesIdRoute,
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(
  AuthedAdminRouteChildren,
)

interface AuthedRouteChildren {
  AuthedShellRoute: typeof AuthedShellRouteWithChildren
  AuthedAdminRoute: typeof AuthedAdminRouteWithChildren
  AuthedAppsRoute: typeof AuthedAppsRoute
  AuthedDeviceRoute: typeof AuthedDeviceRoute
  AuthedOnboardingRoute: typeof AuthedOnboardingRoute
  AuthedSpotifyRoute: typeof AuthedSpotifyRoute
  AuthedStandPlanIdRoute: typeof AuthedStandPlanIdRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedShellRoute: AuthedShellRouteWithChildren,
  AuthedAdminRoute: AuthedAdminRouteWithChildren,
  AuthedAppsRoute: AuthedAppsRoute,
  AuthedDeviceRoute: AuthedDeviceRoute,
  AuthedOnboardingRoute: AuthedOnboardingRoute,
  AuthedSpotifyRoute: AuthedSpotifyRoute,
  AuthedStandPlanIdRoute: AuthedStandPlanIdRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  AuthedRoute: AuthedRouteWithChildren,
  KioskRoute: KioskRoute,
  AcceptInvitationInvitationIdRoute: AcceptInvitationInvitationIdRoute,
  GiveSlugRoute: GiveSlugRoute,
  PreferencesRefRoute: PreferencesRefRoute,
  UnsubscribeRefRoute: UnsubscribeRefRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
